import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  XIcon,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { Button, message } from "antd";
import { HiLink } from "react-icons/hi";
import { InstagramOutlined } from "@ant-design/icons";
import { SiTiktok } from "react-icons/si";

interface ReactShareButtons {
  url?: any;
}
const ShareButtons: React.FC<ReactShareButtons> = () => {
  const userData: any = useAppSelector((state) => state?.profile?.userData);
  const shareUrl = `${process.env.REACT_APP_SPECIAL_URL}?r=${
    userData?.referral_code ?? ""
  }`;

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(shareUrl);
    message.info("Referral url has been copied!");
  };

  return (
    <div className="share__buttons">
      <div className="icon-holder">
        <Button
          size="small"
          shape="round"
          className="copy-button react-share__ShareButton"
          onClick={handleCopyUrl}
        >
          <HiLink size={30} className="copy-button__icon" />
        </Button>
        <h6>Copy Link</h6>
      </div>
      <div className="icon-holder">
        <EmailShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <EmailIcon size={40} round />
        </EmailShareButton>
        <h6>Email</h6>
      </div>
      <div className="icon-holder">
        <FacebookShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <FacebookIcon size={40} round />
        </FacebookShareButton>
        <h6>Facebook</h6>
      </div>
      <div className="icon-holder">
        <Button
          size="small"
          shape="round"
          className="copy-button react-share__ShareButton"
          href="https://www.instagram.com/missingskincare/"
          target="_blank"
        >
          <InstagramOutlined size={30} className="copy-button__icon" />
        </Button>
        <h6>Instagram</h6>
      </div>
      <div className="icon-holder">
        <Button
          size="small"
          shape="round"
          className="copy-button react-share__ShareButton"
          href="https://www.tiktok.com/@missingskincare"
          target="_blank"
        >
          <SiTiktok size={30} className="copy-button__icon" />
        </Button>
        <h6>Tiktok</h6>
      </div>
      <div className="icon-holder">
        <LinkedinShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <LinkedinIcon size={40} round />
        </LinkedinShareButton>
        <h6>Linkedin</h6>
      </div>
      <div className="icon-holder">
        <TwitterShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <XIcon size={40} round />
        </TwitterShareButton>
        <h6>Twitter</h6>
      </div>
      <div className="icon-holder">
        <WhatsappShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <WhatsappIcon size={40} round />
        </WhatsappShareButton>
        <h6>WhatsApp</h6>
      </div>
      <div className="icon-holder">
        <ViberShareButton
          url={shareUrl}
          className="Demo__some-network__share-button"
        >
          <ViberIcon size={40} round />
        </ViberShareButton>
        <h6>Viber</h6>
      </div>
    </div>
  );
};

export default ShareButtons;
